import * as React from 'react'

import { LabelCountry } from "@components"
import { useBuildExternalURL } from "@hooks"


export default function retailerColumn(date) {
	return {
		name: 'retailer', label: 'Retailer',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, { retailerID, asin, country }) => {
				const { productURL } = useBuildExternalURL({ siteData: { siteID: retailerID, asin } })

				return <LabelCountry
				 	label={value}
				 	country={country}
					url={productURL}
				/>
			}
		}
	}
}